import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';

export default {
    name: 'QualificationCheck',
    data: () => ({
        first_names: '',
        surname: '',
        id_number: '',
        qualification: '',
        institution_name: '',
        json_data: {},
        years: Array.from({ length: 75 }, (_, i) => new Date().getFullYear() - i),
        selected_year: '',
    }),
    methods: {
        qualification_check_api() {
            const TOKEN = localStorage.getItem('token');
            const QUALIFICATION_CHECK_API = `${API_BASE_URL}/verify_api/personnel_verification/qualification_check_api/`;

            this.error = '';

            $.ajax({
                url: QUALIFICATION_CHECK_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    first_names: this.first_names,
                    surname: this.surname,
                    id_number: this.id_number,
                    qualification: this.qualification,
                    institution_name: this.institution_name,
                    qualification_year: this.selected_year
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: (response) => {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        confirmButtonText: 'OK'
                    })
                    this.json_data = response.result;
                    $('#verification_results').modal('show');
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    } else {
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    }
                }
            });
        },
    },

    mounted(){
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
